import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import KabobMenuItem from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuItem';
import React from 'react';
import PropTypes from 'prop-types';

const OutcomeAccountSelectionKabobItem = ({ resource }) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { loadModalCollectionByLink } = useModalContext();

  const handleClick = () => {
    loadModalCollectionByLink(resource.relationship(fr.relationships.outcomeAccountSelection.name).link('related').url());
    logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'outcome account selection kabob item');
  };

  return (
    <KabobMenuItem
      label={'Account Selection'}
      onClick={() => {
        handleClick();
      }}
    />
  );
};

OutcomeAccountSelectionKabobItem.defaultProps = {};

OutcomeAccountSelectionKabobItem.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default OutcomeAccountSelectionKabobItem;
